import { useState, useEffect } from "react";
import { Button, Form, Input } from "antd";

import API from "scripts/api";
import Resources from "scripts/resources";

import Rocketman from "images/rocketman.png";
import GoldKey from "images/goldenkey.png";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = () => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting } = state;
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				API.support(values)
					.then(() => {
						form.resetFields();
					})
					.finally(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		document.title = Resources.supportBk;
	};

	useEffect(componentDidMount, []);

	return (
		<div className="page-support">
			<div className="container">
				<img src={Rocketman} alt={Resources.support} className="image" />
				<h1 className="heading">
					<img src={GoldKey} alt={Resources.goldenKey} />
					{Resources.support}
				</h1>
				<Form layout="vertical" form={form}>
					<Form.Item
						name="fullName"
						label={`${Resources.firstName} ${Resources.and} ${Resources.lastName}`}
					>
						<Input size="large" />
					</Form.Item>
					<Form.Item name="phone" label={Resources.mobile}>
						<Input size="large" className="input-ltr" />
					</Form.Item>
					<Form.Item name="subject" label={Resources.subject}>
						<Input size="large" />
					</Form.Item>
					<Form.Item name="text" label={Resources.description}>
						<Input.TextArea rows={6} />
					</Form.Item>
					<Button type="primary" onClick={handleSubmit} loading={submitting}>
						{Resources.submit}
					</Button>
				</Form>
			</div>
		</div>
	);
};

export default Component;
